import { TFPageContent, TFPageHeader } from '@tf/shared';
import { T } from '@tf/utils';
import { PaymentsTable } from '@/components/payments';
import { appStore } from '@/core/stores';

export const PaymentsListRoute = () => {
	const tenant = appStore.tenant?.get();
	T.assertNotNullish(tenant, 'no tenant in appStore');

	return (
		<>
			<TFPageHeader sx={{ marginBottom: 0 }} tenant={tenant} title="Payments" />
			<TFPageContent>
				<PaymentsTable />
			</TFPageContent>
		</>
	);
};
